import { INCREMENT_FAILED_LOGIN, RESET_FAILED_LOGIN } from 'redux/actionTypes';

const initialState = {
    failedLoginAttempts: 0
};

export default function  failedLogin(state = initialState, action) {
    switch(action.type) {
        case INCREMENT_FAILED_LOGIN:
            return {
                failedLoginAttempts: state.failedLoginAttempts + 1
            };
        case RESET_FAILED_LOGIN:
            return {
                failedLoginAttempts: 0
            };
        default:
            return state;
    }
};